import React, { FC } from 'react';
import { GdsFlyAir, Outbound } from 'ts/flight/interfaces/FlightSearch';
import { getLogoUrl, getDaysDifference } from 'utils/utils';
import { getElapsedStr } from 'utils/flight/flight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane } from '@fortawesome/free-solid-svg-icons';
import TicketRouteTime from './TicketRouteTime';
import { HighlightRoute } from 'ts/flight/interfaces/HighlightRoute';
import { useTranslation } from 'react-i18next';
import TicketRouteBaggage from './TicketRouteBaggage';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface TicketRouteGdsProps {
  outbond: Outbound;
  gdsIndex: number;
  highlighted?: HighlightRoute;
  choose: () => void;
}

const TicketRouteGds: FC<TicketRouteGdsProps> = ({ outbond, gdsIndex, highlighted, ...props }) => {
  const [t] = useTranslation();

  const gdsFlyAir: GdsFlyAir = outbond.gdsFlyAirs[gdsIndex];
  const arrivalDaysDifference = getDaysDifference(
    gdsFlyAir.departureDateTime,
    gdsFlyAir.arrivalDateTime
  );

  return (
    <div className="ticket-segment">
      <div className="ticket-route">
        <span className="ticket-airline">
          <img src={getLogoUrl(blobUrl, gdsFlyAir.airline.code)} alt={gdsFlyAir.airline.desc} />
        </span>
        <div className="ticket-data">
          <TicketRouteTime
            dateTime={gdsFlyAir.departureDateTime}
            airportDesc={gdsFlyAir.departureAirport.desc}
            airport={gdsFlyAir.departureAirport.code}
            highlighted={highlighted?.departure}
          />
          <div className="ticket-directions">
            <span className="stops-duration">{getElapsedStr(t, gdsFlyAir.elapsedDTime)}</span>
            <span className="line">
              <FontAwesomeIcon icon={faPlane as any} />
            </span>
          </div>
          <TicketRouteTime
            dateTime={gdsFlyAir.arrivalDateTime}
            airportDesc={gdsFlyAir.arrivalAirport.desc}
            airport={gdsFlyAir.arrivalAirport.code}
            arrivalDaysDifference={arrivalDaysDifference}
            highlighted={highlighted?.arrival}
          />
        </div>
        <TicketRouteBaggage outbond={outbond} choose={props.choose} />
      </div>
      {gdsIndex !== outbond.gdsFlyAirs.length - 1 && (
        <div className="ticket-gds-stop text-lh">
          <span>
            {t('filter.stop_up')} {t('at')}{' '}
          </span>
          <span>{outbond.gdsFlyAirs[gdsIndex].arrivalAirport.cityDesc}</span>
          <br />
          <span>{getElapsedStr(t, outbond.gdsFlyAirs[gdsIndex + 1].connDTime)}</span>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(TicketRouteGds, 'TicketRouteGds');
